<div class="dash-block">
  <div class="dash-block__header">
    <div class="dash-block__title">{{ 'Worked vs. scheduled hours' | translate }}</div>
  </div>
  <div [ngClass]="mode() === 'widget' ? 'dash-block__widget-graph' : 'dash-block__report-graph'">
    @if (isLoading()) {
      <sb-loading-state [style.height]="height()" />
    } @else if (chart()) {
      <sb-chart [type]="chart().type" [data]="chart().data" [options]="chart().options" [height]="height()"></sb-chart>
    }
  </div>
</div>
